/* eslint-disable unused-imports/no-unused-imports */
import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import {Mission} from "../../models/secondary-nav"
import connect from "./connect"

type MissionsProps = {
    data: Mission | null
    department: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const Missions = memo(({data, department, templating}: MissionsProps) => {
    const TemplatedMissionsTitle = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <TemplatedMissionsTitle data={data} department={department} />
        </Suspense>
    )
})
Missions.displayName = "Missions"
export default connect(Missions)
